import type { PickActions } from '@core/ngrx-legacy';
import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { OAuthClientAuth } from '@core/oauth-types';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<OAuthClientAuth[]>()('OAuthClientAuth');

const OAuthClientAuthActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  OAuthClientAuthActions,
  reducer as OAuthClientAuthReducer,
  namespace as OAuthClientAuthNamespace,
  selectors as OAuthClientAuthSelectors,
};
